import { render, staticRenderFns } from "./memberView.vue?vue&type=template&id=634b1220"
import script from "./memberView.vue?vue&type=script&lang=js"
export * from "./memberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports